import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchVehiclesStock = (queryString) => {
  const infoType = queryString.infoType ? `?info_type=${queryString.infoType}` : '?info_type=dealers';
  const dealerRuc = queryString.dealer ? `&dealer_ruc=${queryString.dealer}` : '';
  const model = queryString.model ? `&model=${queryString.model}` : '';
  const reservations = queryString.reservedDealerId ? `&reserved_dealer_ruc=${queryString.reservedDealerId}` : '';

  return apiActionCreator({
    'endpoint': `/vehicles/stock${infoType}${dealerRuc}${model}${reservations}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_VEHICLES_STOCK,
      {
        'type': ActionTypes.FETCHED_VEHICLES_STOCK,
        'payload': queryString.infoType,
      },
      [
        {
          'type': ActionTypes.FETCHED_VEHICLES_STOCK_FAILED,
          'payload': queryString.infoType,
        },
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const clearVehiclesStock = () => ({
  'type': ActionTypes.CLEAR_VEHICLES_STOCK,
});
